// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3XbM1","buttons":"SendReceipts_buttons__oRq3J","email":"SendReceipts_email__1xI3q","bookApptTitle":"SendReceipts_bookApptTitle__1E3je"};